import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class ServerModel {
  constructor() {
    _defineProperty(this, "wixServerParams", void 0);
    this.wixServerParams = this.init();
  }
  init() {
    try {
      var _wixServerDataElement;
      const wixServerDataElement = document.querySelector('#WIX_SERVER_DATA');
      return window.ejsUnserialize((wixServerDataElement == null || (_wixServerDataElement = wixServerDataElement.textContent) == null ? void 0 : _wixServerDataElement.trim()) ?? '{}');
    } catch (err) {
      console.error(`Server Params failed to initialize`, err);
      return {
        locale: 'en',
        geo: 'US'
      };
    }
  }
  get() {
    return this.wixServerParams;
  }
}
//# sourceMappingURL=ServerModel.js.map